<p-dialog
  [header]="'currency.modal-title' | translate"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  (onHide)="closeDialog()"
  [style]="{ width: '60rem', 'max-height': '85vh', 'overflow-y': 'auto' }"
  [focusOnShow]="false"
>
  <div class="modal-body">
    <div class="row mb-3">
      <div class="col-xl-7 d-flex align-items-center">
        <label for="date" class="form-label me-2 bold-label">
          {{ "currency.date" | translate }}
        </label>
        <p-calendar
          dateFormat="dd.mm.yy"
          [(ngModel)]="selectedDate"
          [placeholder]="'currency.date' | translate"
          [showTime]="false"
          [showButtonBar]="true"
          appendTo="body"
          (onSelect)="onDateSelected($event)"
          [maxDate]="maxDate"
        />
      </div>

      <div class="col-xl-5 d-flex align-items-center" >
        <p class="bold-label">
          {{ "currency.latest-updated-date" | translate }}
          :{{ latestUpdatedDate? (latestUpdatedDate | dateFormat : true ):('currency.no-data') | translate}}
        </p>
        <p style="margin-left: 5%" *ngIf="showRefreshButton()">
          <i class="fas fa-sync-alt" (click)="onFetchCurrencies()" role="button"  tabindex="-1"></i>
        </p>
      </div>
    </div>

    <div class="card shadow-sm p-2">
      <div class="row align-items-center">
        <!-- Soldaki dropdown ve input -->
        <div class="col-xl-5 d-flex align-items-center">
          <input
            *ngIf="this.isLeftTL"
            type="text"
            class="form-control"
            id="fromCurrency"
            [(ngModel)]="fromCurrency"
            [disabled]="true"
            style="margin-right: 2%; text-align: right;"
          />
          <p-dropdown
            *ngIf="!this.isLeftTL"
            [options]="currencies"
            [(ngModel)]="toCurrency"
            [showClear]="false"
            [placeholder]="'general.select-please' | translate"
            class="mx-3"
            (ngModelChange)="onToCurrencySelected($event)"
          ></p-dropdown>

          <div class="input-group">
            <input
            type="text"
            class="form-control"
            id="amount"
            [ngModel]="formattedAmount"
            (ngModelChange)="onAmountEntered($event)"
            (blur)="formatAmount()"
            (focus)="removeFormatting()"
            style="margin-right: 2%; text-align: right;"
          />

          </div>
        </div>

        <!-- Switch Butonu -->
        <div class="col-xl-2 d-flex justify-content-center">
          <button class="btn btn-outline-secondary" (click)="swapCurrencies()">
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>

        <!-- Sağdaki dropdown ve input -->
        <div class="col-xl-5 d-flex align-items-center">
          <input
            *ngIf="!this.isLeftTL"
            type="text"
            class="form-control"
            [(ngModel)]="fromCurrency"
            [disabled]="true"
            style="margin-right: 2%; text-align: right;"
          />
          <p-dropdown
            *ngIf="this.isLeftTL"
            [options]="currencies"
            [(ngModel)]="toCurrency"
            [showClear]="false"
            [placeholder]="'general.select-please' | translate"
            class="mx-3"
            (ngModelChange)="onToCurrencySelected($event)"
            [disabled]="!isLeftTL"
          ></p-dropdown>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              id="calculatedAmount"
              [value]="calculatedAmount ? (calculatedAmount | currency:formattedCalculatedAmount():'':'1.2-2') : ''"
              [placeholder]="'currency.amount' | translate"
              [disabled]="true"
              style="margin-right: 2%; text-align: right;"
            />
          </div>
        </div>
      </div>

      <div class="mt-3 text-center">
        <button
          type="button"
          class="btn btn-primary ms-2"
          (click)="calculateAmount()"
        >
          {{ "currency.calculate" | translate }}
        </button>
      </div>
    </div>

    <div class="card shadow">
      <div class="card-body p-0">
        <div class="table-responsive active-projects style-1">
          <div class="tbl-caption">
            <h4 class="heading mb-0">
              {{ "currency.list-table-name" | translate }}
            </h4>
          </div>
          <p-table
            [rowHover]="true"
            responsiveLayout="stack"
            [rows]="rows"
            [first]="first"
            [lazy]="true"
            (onLazyLoad)="getTodayCurrencies(this.selectedDate)"
            paginatorDropdownAppendTo="body"
            [value]="items"
            [totalRecords]="totalRecords"
            [paginator]="false"
          >
            <ng-template pTemplate="header">
              <tr>
                <th scope="col">
                  <span class="p-column-title"
                  >{{ "currency.code" | translate }}
                  </span>
                </th>
                <th scope="col">
                  <span class="p-column-title">
                    {{ "currency.exchange-buy" | translate }}
                  </span>
                </th>
                <th scope="col">
                  <span class="p-column-title">
                    {{ "currency.exchange-sell" | translate }}
                  </span>
                </th>
                <th scope="col">
                  <span class="p-column-title">
                    {{ "currency.effective-buy" | translate }}
                  </span>
                </th>
                <th scope="col">
                  <span class="p-column-title">
                    {{ "currency.effective-sell" | translate }}
                  </span>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-list>
              <tr>
                <td
                  *ngFor="
                    let key of [
                      'code',
                      'forexBuying',
                      'forexSelling',
                      'banknoteBuying',
                      'banknoteSelling'
                    ]
                  "
                  [ngClass]="{
                    selected: selectedValue === list[key],
                    'not-selected':
                      selectedValue && selectedValue !== list[key],
                    disabled:
                      (selectedToCurrency?.label?.split(' ')[1] ||
                        selectedToCurrency?.label) !== list['code']
                  }"
                  (click)="selectValue(list[key])" role="button"  tabindex="-1"
                  style="text-align: left"
                >
                  {{ list[key] }}
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="99">{{ "common.noData" | translate }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
